import {
  TFlexibleBenefitRollover,
  TFlexibleBenefitsBenefitSummary,
  TFlexibleBenefitsPayrollSummary,
  TFlexibleBenefitsSummary,
  TMenhirFlexibleBenefitRollover,
  TMenhirFlexibleBenefitsBenefitSummary,
  TMenhirFlexibleBenefitsSummary,
} from '@/common/integrations/menhir/employee/flexible-benefits/flexible-benefits.types';

export const transformFlexibleBenefitsSummary = (
  summary: TMenhirFlexibleBenefitsSummary
): TFlexibleBenefitsSummary => ({
  status: summary.status,
  benefits: summary.benefits.map((benefit) => ({
    slug: benefit.slug,
    balance: benefit.balance,
  })),
  totalBalance: summary.total_balance,
  renewalDate: summary.renewal_date,
});

export const transformFlexibleBenefitsBenefitSummary = (
  summary: TMenhirFlexibleBenefitsBenefitSummary
): TFlexibleBenefitsBenefitSummary => ({
  currentYear: summary.current_year
    ? {
        limitReached: summary.current_year.limit_reached,
        limit: summary.current_year.limit,
        balance: summary.current_year.balance,
        spent: summary.current_year.spent,
      }
    : undefined,
  currentPeriod: summary.current_period
    ? {
        balance: summary.current_period.balance,
        limit: summary.current_period.limit,
        spent: summary.current_period.spent,
      }
    : undefined,
  fromSalary: summary.from_salary
    ? {
        balance: summary.from_salary.balance,
        limit: summary.from_salary.limit,
        spent: summary.from_salary.spent,
      }
    : undefined,
  accumulated: summary.accumulated
    ? {
        balance: summary.accumulated.balance,
        limit: summary.accumulated.limit,
        spent: summary.accumulated.spent,
      }
    : undefined,
});

export const transformFlexibleBenefitsRollover = (
  rollover: TMenhirFlexibleBenefitRollover
): TFlexibleBenefitRollover => ({
  active: rollover?.active,
  enabled: rollover?.enabled,
  expectedAccumulatedAmount: rollover?.expected_accumulated_amount,
});

export const transformFlexibleBenefitsPayrollSummary = (
  summary: TFlexibleBenefitsPayrollSummary
): TFlexibleBenefitsPayrollSummary => ({
  benefits: summary.benefits.map((benefit) => ({
    slug: benefit.slug,
    amount: benefit.amount,
  })),
  total: summary.total,
});
